import { h } from 'preact'
import sprite from '../../assets/sprite.png'

const CheckboxVisual = ({ checked }) => (
  <div
    style={{
      display: 'inline-block',
      zoom: 1,
      textAlign: 'center',
      background: checked
        ? `url(${sprite}) -327px -408px no-repeat`
        : `url(${sprite}) -327px -368px no-repeat`,
      position: 'absolute',
      left: 0,
      top: 0,
      width: 25,
      height: 25,
    }}
  />
)

const Checkbox = ({ checked, onChange, children, id }) => (
  <div style={{ height: 45 }}>
    <div
      style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: 21,
        lineHeight: '1.5em',
        paddingLeft: 40,
        whiteSpace: 'nowrap',
      }}
    >
      <label htmlFor={id} style={{ userSelect: 'none', fontWeight: 'normal' }}>
        <input
          checked={checked}
          type="checkbox"
          id={id}
          onChange={evt => onChange(evt.target.checked)}
          style={{ display: 'none' }}
        />
        <CheckboxVisual checked={checked} />
        {children}
      </label>
    </div>
  </div>
)
export default Checkbox



// WEBPACK FOOTER //
// ./components/visual/Checkbox.js